import { useMutation } from 'react-query';
import { axiosInstance } from '../../../libs/axiosConfig';

async function postSignOut() {
	return await axiosInstance.post('/auth/sign-out').then((res) => res.data);
}

export const mutateSignOut = () => {
	return useMutation({
		mutationKey: ['sign-out'],
		mutationFn: async () => {
			const data = await postSignOut();

			return data;
		},
	});
};
